import { render, staticRenderFns } from "./ReportGuideWrapper.vue?vue&type=template&id=0a44c8c3"
import script from "./ReportGuideWrapper.vue?vue&type=script&lang=js"
export * from "./ReportGuideWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports